export const getUpdatedLeague = (action, league, matchDayId, matchId) => {
    if(!league) return league;
    return {
        ...league,
        matchDays: league.matchDays.map(
          (matchDay) => {
            if(matchDay.matchDayKey !== matchDayId) {
              return matchDay;
            } else {
                if (action === 'add') {
                    return {
                        ...matchDay,
                        gameDayMatches: [
                            matchId,
                            ...matchDay.gameDayMatches
                        ]
                    }
                }
                if (action === 'delete') {
                    return {
                        ...matchDay,
                        gameDayMatches: matchDay.gameDayMatches?.filter(
                            match => match !== matchId
                          )
                    }
                }
            }
          }
        )
      }
}